// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iHm8f","type":"styles_type__1MWLk","choices":"styles_choices__1weUa"};